export const splitByCharacterLimit = (str: any, limit: number) => {
  const chunks = [];
  let currentChunk = '';

  str?.split(', ').forEach((topic: any) => {
    const topicWithComma = currentChunk ? `, ${topic}` : topic;
    if ((currentChunk + topicWithComma).length <= limit) {
      currentChunk += topicWithComma;
    } else {
      if (currentChunk) chunks.push(currentChunk);
      currentChunk = topic;
    }
  });

  if (currentChunk) chunks.push(currentChunk);
  return chunks;
};
